import React from 'react';
import styled from '@emotion/styled';

const BodyPanel = styled.div(`
    flex: 1;
`);

export default BodyPanel